//
//  Copyright © 2023 Block, Inc. All rights reserved.
//

import AddonEndpoint from './endpoints/addon/addon-endpoint';
import AppEndpoint from './endpoints/app/app-endpoint';
import PendingPromise from './endpoints/shared/pending-promise';

export class Bridge {
  readonly app: AppEndpoint;

  readonly addon: AddonEndpoint;

  constructor(
    pendingAppPromiseWithId: Map<string, PendingPromise> = new Map<
      string,
      PendingPromise
    >()
  ) {
    this.addon = new AddonEndpoint(pendingAppPromiseWithId, () => {});
    this.app = new AppEndpoint(pendingAppPromiseWithId, null);
  }
}

const bridge = new Bridge();
export default bridge;
